export const HUBSPOT_TRACKING_CODE = {
  FOCUS: 'https://js-eu1.hs-scripts.com/26323667.js',
  KALKHOFF: 'https://js-eu1.hs-scripts.com/26545664.js',
  URBANARROW: 'https://js-eu1.hs-scripts.com/25104876.js',
}

export const HUBSPOT_KNOWLEDGEBASE_URLS = {
  FOCUS: 'https://service.focus-bikes.com/knowledgebase',
  KALKHOFF: 'https://service.kalkhoff-bikes.com/knowledge-base',
}

export const HUBSPOT_SUPPORTPORTAL_URLS = {
  FOCUS: 'https://service.focus-bikes.com/tickets-view?offset=0',
  KALKHOFF: 'https://service.kalkhoff-bikes.com/tickets-view?offset=0',
  URBANARROW: 'https://service.urbanarrow.com/tickets-view',
}

export const HUBSPOT_JUMPTO_ICONS = {
  backorder: 'backorder-list',
  BIKES: 'bike',
  downloadDocuments: 'invoice-list',
  engineComplaintFormUrl: 'engine-rma',
  openItems: 'openitems',
  overview: 'r-m-a-list',
  'quick-buy': 'quick-buy',
  SERVICE: 'spare-parts',
  'service-warranty-battery': 'battery-and-charger-rma',
  'service-warranty-components': 'component-rma-tile',
  'service-warranty-return': 'return-request',
  tracking: 'truck',
  addresses: 'customer-addresses',
}

export const HUBSPOT_INSTANCE_ID = {
  FOCUS: '26323667',
  KALKHOFF: '26545664',
  FOCUS_SANDBOX: '27068175',
  KALKHOFF_SANDBOX: '27068179',
  URBANARROW: '25104876',
  URBANARROW_SANDBOX: '25145712',
}

export const HUBSPOT_BRAND_WHITELIST = ['focus', 'kalkhoff', 'urbanarrow']

export const HUBSPOT_FORM_MAPPING = {}

HUBSPOT_FORM_MAPPING[HUBSPOT_INSTANCE_ID['FOCUS_SANDBOX']] = {
  forms: [
    {
      id: '29ee7d2d-a480-415c-bc43-66bb2105e50a',
      name: 'ExampleForm',
    },
    {
      id: 'cc',
      name: 'ExampleForm1',
    },
  ],
}

HUBSPOT_FORM_MAPPING[HUBSPOT_INSTANCE_ID['KALKHOFF_SANDBOX']] = {
  forms: [
    {
      id: 'bb',
      name: 'ExampleForm',
    },
    {
      id: 'xx',
      name: 'ExampleForm1',
    },
  ],
}

HUBSPOT_FORM_MAPPING[HUBSPOT_INSTANCE_ID['URBANARROW']] = {
  forms: [
    {
      id: '28c4f420-c189-43f7-8ff5-dc474d951a14',
      name: 'OtherForm',
    },
    // Warranty Guarantee
    {
      id: 'a1510d68-a5ec-46dc-af00-f21e364a95f3',
      name: 'WarrantyGuaranteeAssemblyComponentDamageForm',
    },
    {
      id: 'a1510d68-a5ec-46dc-af00-f21e364a95f3',
      name: 'WarrantyGuaranteeAssemblyComponentMountedIncorrectlyForm',
    },
    {
      id: 'a1510d68-a5ec-46dc-af00-f21e364a95f3',
      name: 'WarrantyGuaranteeAssemblyPaintDamageForm',
    },
    {
      id: 'a1510d68-a5ec-46dc-af00-f21e364a95f3',
      name: 'WarrantyGuaranteeAssemblyWrongComponentForm',
    },
    {
      id: 'a1510d68-a5ec-46dc-af00-f21e364a95f3',
      name: 'WarrantyGuaranteeBatteryChargerForm',
    },
    {
      id: 'a1510d68-a5ec-46dc-af00-f21e364a95f3',
      name: 'WarrantyGuaranteeGuaranteeForm',
    },
    {
      id: 'a1510d68-a5ec-46dc-af00-f21e364a95f3',
      name: 'WarrantyGuaranteeMotorForm',
    },
    {
      id: 'a1510d68-a5ec-46dc-af00-f21e364a95f3',
      name: 'WarrantyGuaranteePartNotFoundFrameForm',
    },
    {
      id: 'a1510d68-a5ec-46dc-af00-f21e364a95f3',
      name: 'WarrantyGuaranteePartNotFoundOtherComponentForm',
    },
    {
      id: 'a1510d68-a5ec-46dc-af00-f21e364a95f3',
      name: 'WarrantyGuaranteeProductLiabilityForm',
    },
    {
      id: 'a1510d68-a5ec-46dc-af00-f21e364a95f3',
      name: 'WarrantyGuaranteeReplacementAskingDeliveryDateForm',
    },
    {
      id: 'a1510d68-a5ec-46dc-af00-f21e364a95f3',
      name: 'WarrantyGuaranteeReplacementPartMissingForm',
    },
    {
      id: 'a1510d68-a5ec-46dc-af00-f21e364a95f3',
      name: 'WarrantyGuaranteeSparepartDeliveryForm',
    },
    {
      id: 'a1510d68-a5ec-46dc-af00-f21e364a95f3',
      name: 'WarrantyGuaranteeTransportPackagingDamageForm',
    },
    {
      id: 'a1510d68-a5ec-46dc-af00-f21e364a95f3',
      name: 'WarrantyGuaranteeTransportComponentDamageForm',
    },
    {
      id: 'a1510d68-a5ec-46dc-af00-f21e364a95f3',
      name: 'WarrantyGuaranteeTransportPaintDamageForm',
    },
    {
      id: 'a1510d68-a5ec-46dc-af00-f21e364a95f3',
      name: 'WarrantyGuaranteeTransportWholeBikeDamageForm',
    },
    {
      id: 'a1510d68-a5ec-46dc-af00-f21e364a95f3',
      name: 'WarrantyGuaranteeWarrantyClaimForm',
    },
    {
      id: 'a1510d68-a5ec-46dc-af00-f21e364a95f3',
      name: 'WarrantyGuaranteeOtherForm',
    },
    // Master Data
    {
      id: '2003b99f-3561-490e-b955-c64ca99847c9',
      name: 'MasterDataAddressesChangeAddressForm',
    },
    {
      id: '2003b99f-3561-490e-b955-c64ca99847c9',
      name: 'MasterDataAddressesChangeDeliveryAddressForm',
    },
    {
      id: '2003b99f-3561-490e-b955-c64ca99847c9',
      name: 'MasterDataAddressesChangeNameForm',
    },
  ],
}

HUBSPOT_FORM_MAPPING[HUBSPOT_INSTANCE_ID['FOCUS']] = {
  forms: [
    // {
    //   id: '8297c4e5-ec52-4d20-9c69-670141e98257',
    //   name: 'BecomeTradingPartnerForm',
    // },
    // Orders
    {
      id: '4666ba69-3a5d-4d7b-846d-8566f0e9d0a2',
      name: 'OrderBackorderForm',
    },
    {
      id: '4666ba69-3a5d-4d7b-846d-8566f0e9d0a2',
      name: 'OrderChangeCancellationRequestForm',
    },
    {
      id: '4666ba69-3a5d-4d7b-846d-8566f0e9d0a2',
      name: 'OrderChangeDeliveryDateForm',
    },
    {
      id: '4666ba69-3a5d-4d7b-846d-8566f0e9d0a2',
      name: 'OrderChangeExchangeItemForm',
    },
    {
      id: '4666ba69-3a5d-4d7b-846d-8566f0e9d0a2',
      name: 'OrderChangePaymentTermForm',
    },
    {
      id: '4666ba69-3a5d-4d7b-846d-8566f0e9d0a2',
      name: 'OrderRequestBikeForm',
    },
    {
      id: '4666ba69-3a5d-4d7b-846d-8566f0e9d0a2',
      name: 'OrderRequestSparePartAccessoriesForm',
    },
    {
      id: '4666ba69-3a5d-4d7b-846d-8566f0e9d0a2',
      name: 'OrderShippingStatusBikeForm',
    },
    {
      id: '4666ba69-3a5d-4d7b-846d-8566f0e9d0a2',
      name: 'OrderOtherForm',
    },
    // Product Request / Technical Support
    {
      id: '73fb99a9-1240-471d-b70d-2aaf07e5c83d',
      name: 'EbikeSystemsBoschForm',
    },
    {
      id: '73fb99a9-1240-471d-b70d-2aaf07e5c83d',
      name: 'EbikeSystemsContinentalForm',
    },
    {
      id: '73fb99a9-1240-471d-b70d-2aaf07e5c83d',
      name: 'EbikeSystemsFazuaForm',
    },
    {
      id: '73fb99a9-1240-471d-b70d-2aaf07e5c83d',
      name: 'EbikeSystemsGrooveForm',
    },
    {
      id: '73fb99a9-1240-471d-b70d-2aaf07e5c83d',
      name: 'EbikeSystemsImpulseForm',
    },
    {
      id: '73fb99a9-1240-471d-b70d-2aaf07e5c83d',
      name: 'EbikeSystemsShimanoForm',
    },
    {
      id: '73fb99a9-1240-471d-b70d-2aaf07e5c83d',
      name: 'EbikeSystemsXionNeodriveForm',
    },
    {
      id: '73fb99a9-1240-471d-b70d-2aaf07e5c83d',
      name: 'ProductRequestAvailabilityBikeForm',
    },
    {
      id: '73fb99a9-1240-471d-b70d-2aaf07e5c83d',
      name: 'ProductRequestAvailabilitySparePartForm',
    },
    {
      id: '73fb99a9-1240-471d-b70d-2aaf07e5c83d',
      name: 'ProductRequestOtherForm',
    },
    // Payment Terms
    {
      id: '59eeb8da-35df-4de2-8a03-664606bb1784',
      name: 'PaymentTransactionsCreditsForm',
    },
    {
      id: '59eeb8da-35df-4de2-8a03-664606bb1784',
      name: 'PaymentTransactionsInvoiceCorrectionForm',
    },
    {
      id: 'e82480b8-b616-4e0d-ab3d-e5ab566d0514',
      name: 'PaymentTransactionsPaymentAgreementForm',
    },
    {
      id: 'eab9c112-e493-4d88-9d06-d1762899d118',
      name: 'PaymentTransactionsProofOfPaymentForm',
    },
    {
      id: 'f9c21a91-e2c3-483e-bee4-19ab7f0f9339',
      name: 'PaymentTransactionsOtherForm',
    },
    // Feedback
    {
      id: 'd8097dbd-9ea7-4b6e-a8ca-4b38b92fd071',
      name: 'FeedbackDealerportalForm',
    },
    {
      id: 'd8097dbd-9ea7-4b6e-a8ca-4b38b92fd071',
      name: 'FeedbackDeliveryForm',
    },
    {
      id: 'd8097dbd-9ea7-4b6e-a8ca-4b38b92fd071',
      name: 'FeedbackProcessForm',
    },
    {
      id: 'd8097dbd-9ea7-4b6e-a8ca-4b38b92fd071',
      name: 'FeedbackProductForm',
    },
    {
      id: 'd8097dbd-9ea7-4b6e-a8ca-4b38b92fd071',
      name: 'FeedbackSAPForm',
    },
    {
      id: 'd8097dbd-9ea7-4b6e-a8ca-4b38b92fd071',
      name: 'FeedbackServiceForm',
    },
    {
      id: 'd8097dbd-9ea7-4b6e-a8ca-4b38b92fd071',
      name: 'FeedbackTelephoneForm',
    },
    {
      id: 'd8097dbd-9ea7-4b6e-a8ca-4b38b92fd071',
      name: 'FeedbackOtherForm',
    },
    // Master Data
    {
      id: '3bbc7302-1296-4d9b-824f-320be885a316',
      name: 'MasterDataAddressesChangeAddressForm',
    },
    {
      id: '3bbc7302-1296-4d9b-824f-320be885a316',
      name: 'MasterDataAddressesChangeDeliveryAddressForm',
    },
    {
      id: '3bbc7302-1296-4d9b-824f-320be885a316',
      name: 'MasterDataAddressesChangeNameForm',
    },
    // Warranty Guarantee
    {
      id: '2273d79f-4864-4327-b046-8f14f40050dc',
      name: 'WarrantyGuaranteeAssemblyComponentDamageForm',
    },
    {
      id: '2273d79f-4864-4327-b046-8f14f40050dc',
      name: 'WarrantyGuaranteeAssemblyComponentMountedIncorrectlyForm',
    },
    {
      id: '2273d79f-4864-4327-b046-8f14f40050dc',
      name: 'WarrantyGuaranteeAssemblyPaintDamageForm',
    },
    {
      id: '2273d79f-4864-4327-b046-8f14f40050dc',
      name: 'WarrantyGuaranteeAssemblyWrongComponentForm',
    },
    {
      id: '2273d79f-4864-4327-b046-8f14f40050dc',
      name: 'WarrantyGuaranteeBatteryChargerForm',
    },
    {
      id: '2273d79f-4864-4327-b046-8f14f40050dc',
      name: 'WarrantyGuaranteeGuaranteeForm',
    },
    {
      id: '2273d79f-4864-4327-b046-8f14f40050dc',
      name: 'WarrantyGuaranteeMotorForm',
    },
    {
      id: '2273d79f-4864-4327-b046-8f14f40050dc',
      name: 'WarrantyGuaranteePartNotFoundFrameForm',
    },
    {
      id: '2273d79f-4864-4327-b046-8f14f40050dc',
      name: 'WarrantyGuaranteePartNotFoundOtherComponentForm',
    },
    {
      id: '2273d79f-4864-4327-b046-8f14f40050dc',
      name: 'WarrantyGuaranteeProductLiabilityForm',
    },
    {
      id: '2273d79f-4864-4327-b046-8f14f40050dc',
      name: 'WarrantyGuaranteeReplacementAskingDeliveryDateForm',
    },
    {
      id: '2273d79f-4864-4327-b046-8f14f40050dc',
      name: 'WarrantyGuaranteeReplacementPartMissingForm',
    },
    {
      id: '2273d79f-4864-4327-b046-8f14f40050dc',
      name: 'WarrantyGuaranteeSparepartDeliveryForm',
    },
    {
      id: '2273d79f-4864-4327-b046-8f14f40050dc',
      name: 'WarrantyGuaranteeTransportPackagingDamageForm',
    },
    {
      id: '2273d79f-4864-4327-b046-8f14f40050dc',
      name: 'WarrantyGuaranteeTransportComponentDamageForm',
    },
    {
      id: '2273d79f-4864-4327-b046-8f14f40050dc',
      name: 'WarrantyGuaranteeTransportPaintDamageForm',
    },
    {
      id: '2273d79f-4864-4327-b046-8f14f40050dc',
      name: 'WarrantyGuaranteeTransportWholeBikeDamageForm',
    },
    {
      id: '2273d79f-4864-4327-b046-8f14f40050dc',
      name: 'WarrantyGuaranteeWarrantyClaimForm',
    },
    {
      id: '2273d79f-4864-4327-b046-8f14f40050dc',
      name: 'WarrantyGuaranteeOtherForm',
    },
    {
      id: '2b42a302-8eb7-4eb1-bcc0-82fcb3d8d26d',
      name: 'OtherForm',
    },
  ],
}

HUBSPOT_FORM_MAPPING[HUBSPOT_INSTANCE_ID['KALKHOFF']] = {
  forms: [
    // {
    //   id: '8297c4e5-ec52-4d20-9c69-670141e98257',
    //   name: 'BecomeTradingPartnerForm',
    // },
    // Orders
    {
      id: '7c80a8f6-3f94-4332-96af-b7f6502520ad',
      name: 'OrderBackorderForm',
    },
    {
      id: '7c80a8f6-3f94-4332-96af-b7f6502520ad',
      name: 'OrderChangeCancellationRequestForm',
    },
    {
      id: '7c80a8f6-3f94-4332-96af-b7f6502520ad',
      name: 'OrderChangeDeliveryDateForm',
    },
    {
      id: '7c80a8f6-3f94-4332-96af-b7f6502520ad',
      name: 'OrderChangeExchangeItemForm',
    },
    {
      id: '7c80a8f6-3f94-4332-96af-b7f6502520ad',
      name: 'OrderChangePaymentTermForm',
    },
    {
      id: '7c80a8f6-3f94-4332-96af-b7f6502520ad',
      name: 'OrderRequestBikeForm',
    },
    {
      id: '7c80a8f6-3f94-4332-96af-b7f6502520ad',
      name: 'OrderRequestSparePartAccessoriesForm',
    },
    {
      id: '7c80a8f6-3f94-4332-96af-b7f6502520ad',
      name: 'OrderShippingStatusBikeForm',
    },
    {
      id: '7c80a8f6-3f94-4332-96af-b7f6502520ad',
      name: 'OrderOtherForm',
    },
    // Product Request / Technical Support
    {
      id: '78bb6f06-1f36-40d9-a5d6-bee27a8bd160',
      name: 'EbikeSystemsBoschForm',
    },
    {
      id: '78bb6f06-1f36-40d9-a5d6-bee27a8bd160',
      name: 'EbikeSystemsContinentalForm',
    },
    {
      id: '78bb6f06-1f36-40d9-a5d6-bee27a8bd160',
      name: 'EbikeSystemsFazuaForm',
    },
    {
      id: '78bb6f06-1f36-40d9-a5d6-bee27a8bd160',
      name: 'EbikeSystemsGrooveForm',
    },
    {
      id: '78bb6f06-1f36-40d9-a5d6-bee27a8bd160',
      name: 'EbikeSystemsImpulseForm',
    },
    {
      id: '78bb6f06-1f36-40d9-a5d6-bee27a8bd160',
      name: 'EbikeSystemsShimanoForm',
    },
    {
      id: '78bb6f06-1f36-40d9-a5d6-bee27a8bd160',
      name: 'EbikeSystemsXionNeodriveForm',
    },
    {
      id: '78bb6f06-1f36-40d9-a5d6-bee27a8bd160',
      name: 'ProductRequestAvailabilityBikeForm',
    },
    {
      id: '78bb6f06-1f36-40d9-a5d6-bee27a8bd160',
      name: 'ProductRequestAvailabilitySparePartForm',
    },
    {
      id: '78bb6f06-1f36-40d9-a5d6-bee27a8bd160',
      name: 'ProductRequestOtherForm',
    },
    // Payment Terms
    {
      id: '9c0dec88-34d4-4b27-a0c1-eaf367c0cf0f',
      name: 'PaymentTransactionsCreditsForm',
    },
    {
      id: '9c0dec88-34d4-4b27-a0c1-eaf367c0cf0f',
      name: 'PaymentTransactionsInvoiceCorrectionForm',
    },
    {
      id: 'b2d03e03-55fb-4066-bbc0-45f3fbd2522c',
      name: 'PaymentTransactionsPaymentAgreementForm',
    },
    {
      id: '506da357-6026-46f1-95e5-79e06e0fc5ea',
      name: 'PaymentTransactionsProofOfPaymentForm',
    },
    {
      id: 'c251073e-e21f-42a4-a3c3-ab0bef05bfab',
      name: 'PaymentTransactionsOtherForm',
    },
    // Feedback
    {
      id: '553eb8dd-82fb-410a-b340-cb92eb665220',
      name: 'FeedbackDealerportalForm',
    },
    {
      id: '553eb8dd-82fb-410a-b340-cb92eb665220',
      name: 'FeedbackDeliveryForm',
    },
    {
      id: '553eb8dd-82fb-410a-b340-cb92eb665220',
      name: 'FeedbackProcessForm',
    },
    {
      id: '553eb8dd-82fb-410a-b340-cb92eb665220',
      name: 'FeedbackProductForm',
    },
    {
      id: '553eb8dd-82fb-410a-b340-cb92eb665220',
      name: 'FeedbackSAPForm',
    },
    {
      id: '553eb8dd-82fb-410a-b340-cb92eb665220',
      name: 'FeedbackServiceForm',
    },
    {
      id: '553eb8dd-82fb-410a-b340-cb92eb665220',
      name: 'FeedbackTelephoneForm',
    },
    {
      id: '553eb8dd-82fb-410a-b340-cb92eb665220',
      name: 'FeedbackOtherForm',
    },
    // Master Data
    {
      id: '099ead75-f769-4738-8414-ef6abc631387',
      name: 'MasterDataAddressesChangeAddressForm',
    },
    {
      id: '099ead75-f769-4738-8414-ef6abc631387',
      name: 'MasterDataAddressesChangeDeliveryAddressForm',
    },
    {
      id: '099ead75-f769-4738-8414-ef6abc631387',
      name: 'MasterDataAddressesChangeNameForm',
    },
    // Warranty Guarantee
    {
      id: '404e9c1b-7f5c-4e19-baba-a1952f8a3400',
      name: 'WarrantyGuaranteeAssemblyComponentDamageForm',
    },
    {
      id: '404e9c1b-7f5c-4e19-baba-a1952f8a3400',
      name: 'WarrantyGuaranteeAssemblyComponentMountedIncorrectlyForm',
    },
    {
      id: '404e9c1b-7f5c-4e19-baba-a1952f8a3400',
      name: 'WarrantyGuaranteeAssemblyPaintDamageForm',
    },
    {
      id: '404e9c1b-7f5c-4e19-baba-a1952f8a3400',
      name: 'WarrantyGuaranteeAssemblyWrongComponentForm',
    },
    {
      id: '404e9c1b-7f5c-4e19-baba-a1952f8a3400',
      name: 'WarrantyGuaranteeBatteryChargerForm',
    },
    {
      id: '404e9c1b-7f5c-4e19-baba-a1952f8a3400',
      name: 'WarrantyGuaranteeGuaranteeForm',
    },
    {
      id: '404e9c1b-7f5c-4e19-baba-a1952f8a3400',
      name: 'WarrantyGuaranteeMotorForm',
    },
    {
      id: '404e9c1b-7f5c-4e19-baba-a1952f8a3400',
      name: 'WarrantyGuaranteePartNotFoundFrameForm',
    },
    {
      id: '404e9c1b-7f5c-4e19-baba-a1952f8a3400',
      name: 'WarrantyGuaranteePartNotFoundOtherComponentForm',
    },
    {
      id: '404e9c1b-7f5c-4e19-baba-a1952f8a3400',
      name: 'WarrantyGuaranteeProductLiabilityForm',
    },
    {
      id: '404e9c1b-7f5c-4e19-baba-a1952f8a3400',
      name: 'WarrantyGuaranteeReplacementAskingDeliveryDateForm',
    },
    {
      id: '404e9c1b-7f5c-4e19-baba-a1952f8a3400',
      name: 'WarrantyGuaranteeReplacementPartMissingForm',
    },
    {
      id: '404e9c1b-7f5c-4e19-baba-a1952f8a3400',
      name: 'WarrantyGuaranteeSparepartDeliveryForm',
    },
    {
      id: '404e9c1b-7f5c-4e19-baba-a1952f8a3400',
      name: 'WarrantyGuaranteeTransportPackagingDamageForm',
    },
    {
      id: '404e9c1b-7f5c-4e19-baba-a1952f8a3400',
      name: 'WarrantyGuaranteeTransportComponentDamageForm',
    },
    {
      id: '404e9c1b-7f5c-4e19-baba-a1952f8a3400',
      name: 'WarrantyGuaranteeTransportPaintDamageForm',
    },
    {
      id: '404e9c1b-7f5c-4e19-baba-a1952f8a3400',
      name: 'WarrantyGuaranteeTransportWholeBikeDamageForm',
    },
    {
      id: '404e9c1b-7f5c-4e19-baba-a1952f8a3400',
      name: 'WarrantyGuaranteeWarrantyClaimForm',
    },
    {
      id: '404e9c1b-7f5c-4e19-baba-a1952f8a3400',
      name: 'WarrantyGuaranteeOtherForm',
    },
    {
      id: '7236b959-2f82-4b14-aa56-632afe6a34c2',
      name: 'OtherForm',
    },
  ],
}

export const HUBSPOT_SUBJECT_TRANSLATIONS = {
  'Order - Request Bike': {
    de: 'Order - Bestellanfrage Fahrrad',
    fr: 'Commande - Demande de commande vélo',
    es: 'Pedido - Pedir bicicleta',
    pl: 'Zamówienie - Zapytaj o rower',
    nl: 'Bestelling - bestelaanvraag fiets',
  },
  'Order - Request spare part/ equipment': {
    de: 'Order - Bestellanfrage Ersatzteil',
    fr: 'Commande - Demande de commande pièce détachée',
    es: 'Pedido - Solicitar recambio/equipación',
    pl: 'Zamówienie - Zapytaj o części zamienne/sprzęt',
    nl: 'Bestelling - bestelaanvraag voor reserveonderdelen',
  },
  'Order - Shipping status of bike': {
    de: 'Order - Versandstatus Fahrrad',
    fr: "Commande - statut d'envoi vélo",
    es: 'Pedido - Estado de envío de la bicicleta',
    pl: 'Zamówienie - Status wysyłki roweru',
    nl: 'Bestelling - verzendstatus fiets',
  },
  'Order change - cancellation request': {
    de: 'Order - Stornoanfrage',
    fr: "Commande - Demande d'annulation",
    es: 'Cambiar pedido - Solicitud de cancelación',
    pl: 'Zmiana zamówienia - prośba o anulowanie',
    nl: 'Bestelling - annuleringsverzoek',
  },
  'Order change - exchange items': {
    de: 'Order - Artikel tauschen',
    fr: 'Commande - Remplacer un article',
    es: 'Cambiar pedido - Cambiar artículos',
    pl: 'Zmiana zamówienia - wymiana elementów',
    nl: 'Bestelling - artikel ruilen',
  },
  'Order Change - Change delivery date': {
    de: 'Order - Lieferdatum ändern',
    fr: 'Commande - Changer une date de livraison',
    es: 'Cambiar pedido - Modificar fecha de entrega',
    pl: 'Zmiana zamówienia - zmiana daty dostawy',
    nl: 'Bestelling - wijzig leverdatum',
  },
  'Order Change - Change payment term': {
    de: 'Order - Zahlungsziel ändern',
    fr: 'Commande - Modifier délai de paiement',
    es: 'Cambiar pedido - Cambiar plazo de pago',
    pl: 'Zmiana zamówienia - zmiana terminu płatności',
    nl: 'Bestelling - betalingsuitstel wijzigen',
  },
  'Order - Overview Backorder': {
    de: 'Order - Übersicht Rückstände',
    fr: 'Commande - Aperçu rellquat',
    es: 'Pedido - Resumen Backorder',
    pl: 'Zamówienie - Przegląd Backorderu',
    nl: 'Bestelling - overzicht backorders',
  },
  'Order - Other': {
    de: 'Order - Sonstiges',
    fr: 'Commande - autres',
    es: 'Pedido - Otros',
    pl: 'Zamówienie - Inne',
    nl: 'Bestelling - overige',
  },
  'Product availability bike': {
    de: 'Verfügbarkeit Fahrrad',
    fr: 'Disponibilité vélo',
    es: 'Disponibilidad de bicicleta',
    pl: 'Dostępność roweru',
    nl: 'Beschikbaarheid fiets',
  },
  'Product availability part': {
    de: 'Verfügbarkeit Ersatzteil',
    fr: 'Disponibilité pièce détachée',
    es: 'Disponibilidad de pieza',
    pl: 'Dostępność części',
    nl: 'Beschikbaarheid reserveonderdeel',
  },
  'techn. Support - Impulse': {
    de: 'techn. Support - Impulse',
    fr: 'Soutien technique - Impulse',
    es: 'techn. Support - Impulse',
    pl: 'Wsparcie techniczne - Impulse',
    nl: 'Techn. support - Impulse',
  },
  'techn. Support - Bosch': {
    de: 'techn. Support - Bosch',
    fr: 'Soutien technique - Bosch',
    es: 'techn. Support - Bosch',
    pl: 'Wsparcie techniczne - Bosch',
    nl: 'Techn. support - Bosch',
  },
  'techn. Support - Shimano': {
    de: 'techn. Support - Shimano',
    fr: 'Soutien technique - Shimano',
    es: 'techn. Support - Shimano',
    pl: 'Wsparcie techniczne - Shimano',
    nl: 'Techn. support - Shimano',
  },
  'techn. Support - Fazua': {
    de: 'techn. Support - Fazua',
    fr: 'Soutien technique - Fazua',
    es: 'techn. Support - Fazua',
    pl: 'Wsparcie techniczne - Fazua',
    nl: 'Techn. support - Fazua',
  },
  'techn. Support - Groove': {
    de: 'techn. Support - Groove',
    fr: 'Soutien technique - Groove',
    es: 'techn. Support - Groove',
    pl: 'Wsparcie techniczne - Groove',
    nl: 'Techn. support - Groove',
  },
  'techn. Support - Continental': {
    de: 'techn. Support - Continental',
    fr: 'Soutien technique - Continental',
    es: 'techn. Support - Continental',
    pl: 'Wsparcie techniczne - Continental',
    nl: 'Techn. support - Continental',
  },
  'techn. Support - Xion/Neodrive': {
    de: 'techn. Support - Xion/Neodrive',
    fr: 'Soutien technique - Xion/Neodrive',
    es: 'techn. Support - Xion/Neodrive',
    pl: 'Wsparcie techniczne - Xion/Neodrive',
    nl: 'Techn. support - Xion/Neodrive',
  },
  'Product availability / technical support - Other': {
    de: 'Verfügbarkeit / techn. support - Sonstiges',
    fr: 'Disponibilité / soutien technique - autres',
    es: 'Disponibilidad de productos / asistencia técnica - Otros',
    pl: 'Dostępność produktów / wsparcie techniczne - Inne',
    nl: 'Beschikbaarheid / technische ondersteunding - overige',
  },
  'Payment transaction - invoice correction': {
    de: 'Zahlungstransaktionen - Rechnungskorrektur',
    fr: 'Transactions de paiement - Correction de facture',
    es: 'Transacción de pago - corrección de factura',
    pl: 'Transakcja płatnicza - korekta faktury',
    nl: 'Betalingstransacties - factuurcorrectie',
  },
  'Payment transactions - Credit Note': {
    de: 'Zahlungstransaktionen - Gutschrift',
    fr: 'Transactions de paiement - Avoir',
    es: 'Transacción de pago - abono',
    pl: 'Transakcja płatnicza - Nota kredytowa',
    nl: 'Betalingstransacties - creditnota',
  },
  'Payment transactions - Payment agreement': {
    de: 'Zahlungstransaktionen - Zahlungsvereinbarung',
    fr: 'Transactions de paiement - Accord de paiement',
    es: 'Transacción de pago - acuerdo de pago',
    pl: 'Transakcja płatnicza - Porozumienie w sprawie płatności',
    nl: 'Betalingstransacties - betalingsovereenkomst',
  },
  'Payment transactions - Proof of payment': {
    de: 'Zahlungstransaktionen - Zahlungsnachweis',
    fr: 'Transactions de paiement - Preuve de paiement',
    es: 'Transacción de pago - justificante de pago',
    pl: 'Transakcja płatnicza - Potwierdzenie płatności',
    nl: 'Betalingstransacties - bewijs van betaling',
  },
  'Payment transactions - Other': {
    de: 'Zahlungstransaktionen - Sonstiges',
    fr: 'Transactions de paiement - Autres',
    es: 'Transacción de pago - otros',
    pl: 'Transakcja płatnicza - Inne',
    nl: 'Betalingstransacties - overige',
  },
  'Payment transactions - Others': {
    de: 'Zahlungstransaktionen - Sonstiges',
    fr: 'Transactions de paiement - Autres',
    es: 'Transacción de pago - otros',
    pl: 'Transakcja płatnicza - Inne',
    nl: 'Betalingstransacties - overige',
  },
  'Feedback Dealer Portal': {
    de: 'Feedback Dealer Portal',
    fr: 'Commentaires Portail des revendeurs',
    es: 'Comentarios Dealer Portal',
    pl: 'Feedback Portal Dealera',
    nl: 'Feedback dealer portal',
  },
  'Feedback Process': {
    de: 'Feedback Prozess',
    fr: 'Commentaires Processus',
    es: 'Comentarios Proceso',
    pl: 'Feedback Proces',
    nl: 'Feedback proces',
  },
  'Feedback SAP': {
    de: 'Feedback SAP',
    fr: 'Commentaires SAP',
    es: 'Comentarios SAP',
    pl: 'Feedback SAP',
    nl: 'Feedack SAP',
  },
  'Feedback Service': {
    de: 'Feedback Service',
    fr: 'Commentaires Service',
    es: 'Comentarios Servicio',
    pl: 'Feedback Serwis',
    nl: 'Feedback Service',
  },
  'Feedback Product': {
    de: 'Feedback Produkt',
    fr: 'Commentaires Produit',
    es: 'Comentarios Producto',
    pl: 'Feedback Produkt',
    nl: 'Feedback product',
  },
  'Feedback Delivery': {
    de: 'Feedback Lieferung',
    fr: 'Commentaires Livraison',
    es: 'Comentarios Entrega',
    pl: 'Feedback Dostawa',
    nl: 'Feedback levering',
  },
  'Feedback Telephone Contact': {
    de: 'Feedback Telefonkontakt',
    fr: 'Commentaires Contact téléphonique',
    es: 'Comentarios Contacto telefónico',
    pl: 'Feedback Kontakt telefoniczny',
    nl: 'Feedback telefonisch contact',
  },
  'Feedback Other': {
    de: 'Feedback Sonstiges',
    fr: 'Commentaires Autres',
    es: 'Comentarios Otros',
    pl: 'Feedback Inne',
    nl: 'Feedback overige',
  },
  'Master data and addresses - Change of name - Change of ownership': {
    de: 'Stammdaten & Adressen - Änderung Name / Inhaberschaft',
    fr: 'Données de base et adresses - modification du nom / de la propriété',
    es: 'Datos principales y direcciones - Cambio de nombre/propiedad',
    pl: 'Dane podstawowe i adresy - Zmiana nazwy/zmiana właściciela',
    nl: 'Gegevens & adressen - Naam/eigendom wijzigen',
  },
  'Master data and addresses - Change of ownership': {
    de: 'Stammdaten & Adressen - Änderung Inhaberschaft',
    fr: 'Données de base et adresses - modification de la propriété',
    es: 'Datos principales y direcciones - Cambio de propiedad',
    pl: 'Dane podstawowe i adresy - Zmiana właściciela',
    nl: 'Gegevens & adressen - Eigendom wijzigen',
  },
  'Master data and addresses - Other': {
    de: 'Stammdaten & Adressen - Sonstiges',
    fr: 'Données de base et adresses - Autres',
    es: 'Datos principales y direcciones - Otros',
    pl: 'Dane podstawowe i adresy - Inne',
    nl: 'Gegevens & adressen - Overige',
  },
  'Warranty - piece not found - frame': {
    de: 'Gewährleistung/Garantie - Teil nicht gefunden - Rahmen',
    fr: 'Garantie - Pièce introuvable - Cadre',
    es: 'Garantía - pieza no encontrada - cuadro',
    pl: 'Gwarancja - nie znaleziono części - rama',
    nl: 'Garantie - Onderdeel niet gevonden - Frame',
  },
  'Warranty - piece not found - component': {
    de: 'Gewährleistung/Garantie - Teil nicht gefunden - Komponente',
    fr: 'Garantie - Pièce introuvable - Composant',
    es: 'Garantía - pieza no encontrada - componente',
    pl: 'Gwarancja - nie znaleziono części - komponent',
    nl: 'Garantie/garantie - Onderdeel niet gevonden - Component',
  },
  'Warranty - Transport damage - paint damage': {
    de: 'Gewährleistung/Garantie - Transportschaden - Lackschaden',
    fr: 'Garantie - Dommage de transport - Dommage de peinture',
    es: 'Garantía - Daños de transporte - Daños de pintura',
    pl: 'Gwarancja - Uszkodzenia transportowe - Uszkodzenia lakieru',
    nl: 'Garantie - Transportschade - Lakschade',
  },
  'Warranty - Transport damage - packing damaged': {
    de: 'Gewährleistung/Garantie - Transportschaden - Verpackung beschädigt',
    fr: 'Garantie - Dommage de transport - Emballage endommagé',
    es: 'Garantía - Daños de transporte - embalaje dañado',
    pl: 'Gwarancja - Uszkodzenia transportowe - Uszkodzenie opakowania',
    nl: 'Garantie - Transportschade - Verpakking beschadigd',
  },
  'Warranty - Transport damage - component damaged': {
    de: 'Gewährleistung/Garantie - Transportschaden - Komponente beschädigt',
    fr: 'Garantie - Dommage de transport - Composant endommagé',
    es: 'Garantía - Daños de transporte - Componente dañado',
    pl: 'Gwarancja - Uszkodzenia transportowe - Uszkodzenie komponentu',
    nl: 'Garantie - Transportschade - Component beschadigd',
  },
  'Warranty - Transport damage - bike damaged': {
    de: 'Gewährleistung/Garantie - Transportschaden - Fahrrad beschädigt',
    fr: 'Garantie - Dommage de transport - Vélo abîmé',
    es: 'Garantía - Daños de transporte - bicicleta dañada',
    pl: 'Gwarancja - Uszkodzenia transportowe - Uszkodzenie roweru',
    nl: 'Garantie - Transportschade - Fiets beschadigd',
  },
  'Warranty - Assembly quality - paint damage': {
    de: 'Gewährleistung/Garantie - Montageschaden - Lackschaden',
    fr: 'Garantie - Dommage de montage - Dommage de peinture',
    es: 'Garantía - Calidad de montaje - Daños en la pintura',
    pl: 'Gwarancja - Jakość montażu - Uszkodzenia lakieru',
    nl: 'Garantie - Montageschade - Lakschade',
  },
  'Warranty - Assembly quality - component damaged': {
    de: 'Gewährleistung/Garantie - Montageschaden - Komponente beschädigt',
    fr: 'Garantie - Dommage de montage - Composant endommagé',
    es: 'Garantía - Calidad de montaje - componente dañado',
    pl: 'Gwarancja - Jakość montażu - Uszkodzenie komponentu',
    nl: 'Garantie - Montageschade - Component beschadigd',
  },
  'Warranty - Assembly quality - component assembly': {
    de: 'Gewährleistung/Garantie - Montageschaden - Komponente falsch verbaut',
    fr: 'Garantie - Dommage de montage - Composant mal monté',
    es: 'Garantía - Calidad de montaje - montaje de componentes',
    pl: 'Gwarancja - Jakość montażu - Montaż podzespołów',
    nl: 'Garantie - Montageschade - Component verkeerd gemonteerd',
  },
  'Warranty - Assembly quality - wrong component': {
    de: 'Gewährleistung/Garantie - Montageschaden - falsche Komponente verbaut',
    fr: 'Garantie - Dommage de montage - mauvais composant installé',
    es: 'Garantía - Calidad de montaje - componente erróneo',
    pl: 'Gwarancja - Jakość montażu - Niewłaściwy komponent',
    nl: 'Garantie - Montageschade - Verkeerd onderdeel gemonteerd',
  },
  'Warranty request': {
    de: 'Gewährleistung/Garantie - Anspruch',
    fr: 'Garantie - Droit',
    es: 'Solicitud de garantía',
    pl: 'Wniosek o gwarancję',
    nl: 'Garantieaanvraag',
  },
  'Warranty - replacement delivery - missing part': {
    de: 'Gewährleistung/Garantie - Ersatzlieferung - Teil fehlt bei Lieferung',
    fr: 'Garantie - Remplacement - Pièce manquante à la livraison',
    es: 'Garantía - entrega de sustitución - pieza faltante',
    pl: 'Gwarancja - dostawa zastępcza - brakująca część',
    nl: 'Garantie - Vervangende levering - Onderdeel ontbreekt bij levering',
  },
  'Warranty - replacement delivery - status?': {
    de: 'Gewährleistung/Garantie - Ersatzlieferung - Wo ist meine Lieferung?',
    fr: 'Garantie - Remplacement - Où est ma livraison ?',
    es: 'Garantía - entrega de sustitución - ¿estado?',
    pl: 'Gwarancja - dostawa zastępcza  Status?',
    nl: 'Garantie - Vervangende levering - Waar is mijn levering?',
  },
  'Warranty - product liability': {
    de: 'Gewährleistung/Garantie - Produkthaftung',
    fr: 'Garantie - Responsabilité du fait des produits',
    es: 'Garantía - responsabilidad sobre el producto',
    pl: 'Gwarancja - odpowiedzialność za produkt',
    nl: 'Garantie - Productaansprakelijkheid',
  },
  'Warranty - Other': {
    de: 'Gewährleistung/Garantie - Sonstiges',
    fr: 'Garantie - Autres',
    es: 'Garantía - Otros',
    pl: 'Gwarancja - Inne',
    nl: 'Garantie - Overige',
  },
  Other: {
    de: 'Sonstiges',
    fr: 'Autres',
    es: 'Otros',
    pl: 'Inne',
    nl: 'Overige',
  },
}
